__turbopack_context__.v({
  "text": "_6yj26q_text",
  "vertical": "_6yj26q_vertical",
});
